import styled from 'styled-components';

export const StyledNoticeInfo = styled.div`
  display: flex;
  flex-direction: column;
  color: var(--color-text-main);
  width: 350px;
  padding: 15px;
  box-shadow: 0px 0px 6px 0px #00000026;
  border-radius: 5px;
  background-color: #ffffff;

  .component-title {
    font-size: 16px;
    font-weight: 600;
    color: #2f2f35;
    margin-bottom: 10px;
  }

  .component-body {
    display: flex;
    flex-direction: row;
  }

  .item-list {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .item {
    display: flex;
    flex-direction: row;
    padding: 5px;
    gap: 2px;
  }

  .item-icon {
    font-size: 12px;
    font-weight: 500;
    color: #2f2f35;
  }

  .item-title {
    font-size: 12px;
    font-weight: 500;
    color: #2f2f35;
    width: 230px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .item-date {
    font-size: 12px;
    font-weight: 500;
    color: #2f2f35;
    padding-left: 10px;
  }
`;
